import UrlSearchParams from 'url-search-params'
import { getDeviceId, isSeparateSubscription } from '../services/conf-utils'
import { getMappTrackingParameters } from '../services/tracking'

const json = document.getElementById('state')
const confVariables = JSON.parse(json ? json.text : '{"mock": "value"}')
const postMessAddress = document.referrer === '' ? '*' : document.referrer
const urlParams = new UrlSearchParams(window.location.search)
const checkoutHosts = [
  '127.0.0.1:8000',
  'checkout.timeout.com',
]

export default {
  SESSION_API_URL: confVariables.SESSION_API_URL,
  SOCIAL_OAUTH2_LOGIN: confVariables.SOCIAL_OAUTH2_LOGIN,
  LIST_ALLOW_DOMAINS: confVariables.LIST_ALLOW_DOMAINS,
  TWITTER_URI: `${confVariables.SESSION_API_URL}/helper/twitter`,
  FACEBOOK_APP_ID: confVariables.FACEBOOK_APP_ID,
  GOOGLE_CLIENT_ID: confVariables.GOOGLE_CLIENT_ID,
  SOCIAL_TOKEN: 'csrftoken',
  TWITTER_TOKEN: 'twitter_oauth_token',
  TWITTER_SECRET: 'twitter_oauth_token_secret',
  CLIENT_ID: confVariables.CLIENT_ID,
  CLIENT_SECRET: confVariables.CLIENT_SECRET,
  POST_MESSAGE_ADDRESS: postMessAddress,
  USER_ACTIONS: {
    register: { actionType: 'register' },
    login: { actionType: 'login' },
    logout: { actionType: 'logout' },
    analytics: { actionType: 'analytics' },
  },
  TWITTER_MODAL_HEIGHT: 410,
  TWITTER_MODAL_WIDTH: 680,
  LOCALE: urlParams.get('locale') || 'en-GB',
  // Graffiti site-id
  SITE: urlParams.get('site') || null,
  IS_COOKIE_SETTABLE: urlParams.get('isCookieSettable') || true,
  PAGES: confVariables.PAGES || {},
  DEVICE_ID: getDeviceId(),
  SEPARATE_SUBSCRIPTION: isSeparateSubscription(
    window.location,
    window.parent.location,
    document.referrer,
    checkoutHosts,
    confVariables,
  ),
  MAPP_TRACKING_PARAMETERS: getMappTrackingParameters(),
  AUTH_MIN_PASSWORD_LENGTH: confVariables.AUTH_MIN_PASSWORD_LENGTH,
  AUTH_MAX_PASSWORD_LENGTH: confVariables.AUTH_MAX_PASSWORD_LENGTH,
}



// WEBPACK FOOTER //
// ./src/constants/index.js